import { useRef, useEffect } from "react";

const useTitle = (title) => {
  const documentDefined = typeof document !== "undefined";
  const originalTitle = useRef(documentDefined ? document.title : null);

  useEffect(() => {
    if (!documentDefined) return;

    // Zatečeni naslov se hvata pri POKRETANJU effect-a, ne pri čišćenju.
    // `originalTitle.current` se u čišćenju čita tek kad se komponenta skida,
    // a dotle je mogao da se promeni — pa bi se vratio pogrešan naslov.
    const zateceni = originalTitle.current;

    if (document.title !== title) document.title = `Inery DB GUI | ${title}`;

    return () => {
      document.title = zateceni;
    };
    // `title` je bio izostavljen, pa se naslov postavljao samo jednom: ekran
    // koji ga menja u hodu ostajao bi na starom.
  }, [documentDefined, title]);
};

export default useTitle;
